<div class="rx-cover" [class.rx-cover--hero]="mode === 'hero'">
  <div class="rx-cover__meta">
    <img class="rx-cover__logo" src="assets/images/logo.svg" alt="RA Capital">
    <div class="rx-cover__release">
      <h2 class="rx-cover__version" [attr.id]="labelId">{{ "RELEASE_NOTES.CARD.VERSION" | translate: { version: cover?.version } }}</h2>
      <div class="rx-cover__sub">{{ "RELEASE_NOTES.CARD.PRODUCT" | translate }}</div>
      <div class="rx-cover__when">{{ cover?.releaseDateLabel }}</div>
    </div>
    <div class="rx-cover__foot">
      <div class="rx-cover__credit" *ngIf="credit.artist">
        <div>
          {{ "RELEASE_NOTES.CARD.ARTWORK_BY" | translate }} <b>{{ credit.artist }}</b>
          <span class="rx-cover__grade" *ngIf="credit.inline">{{ credit.inline }}</span>
        </div>
        <div class="rx-cover__grade" *ngIf="credit.secondRow">{{ credit.secondRow }}</div>
      </div>
      <div class="rx-cover__actions" *ngIf="showSeeWhatsNew || secondaryKey">
        <button *ngIf="showSeeWhatsNew" type="button" class="btn btn-teal rx-cover__cta" (click)="seeWhatsNew.emit()">
          {{ "RELEASE_NOTES.CARD.SEE_WHATS_NEW" | translate }}
        </button>
        <button *ngIf="secondaryKey" type="button" class="btn btn-outline-teal rx-cover__cta" (click)="secondary.emit()">
          {{ secondaryKey | translate }}
        </button>
      </div>
    </div>
  </div>
  <div class="rx-cover__art">
    <div class="rx-cover__frame">
      <img *ngIf="coverUrl && !artFailed" [src]="coverUrl"
           [attr.alt]="'RELEASE_NOTES.CARD.COVER_ALT' | translate: { artist: credit.artist }"
           (error)="artFailed = true">
    </div>
  </div>
</div>
